// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/modules/_enum-bug-keys.js
// module id = 48
// module chunks = 0 1 2 3 4